<template>
  <div class="card-function-bar">
    <div v-if="isCardRealShow" class="card-wrap">
      <div class="card-item card-user">
        <a
          class="name-card"
          href="javascript:;"
          data-stat-id="name"
          :data-stat-ep="
            JSON.stringify({
              productId: data.insuranceTypeId,
            })
          "
          @click="jumpToCard(data.nameCard)"
        >
          <div class="head" :class="{ circle: !isToB }">
            <img :src="resizePicture(data.photo, 80)" :alt="data.name">
          </div>
          <div class="info" :class="{ member: isMember }">
            <p class="name">
              <span>{{ data.name }}</span>
              <i v-if="isMedalShow" class="icon-member">
                <img :src="data.memberLevelMedal" :alt="data.memberLevelName">
              </i>
            </p>
            <p v-if="data.offlineBroker">{{ isBxs ? '保险师' : '' }}专员</p>
            <p v-else-if="data.memberLevelName">{{ data.memberLevelName }}</p>
          </div>
        </a>
      </div>
      <div class="card-item card-telephone" :class="{ line: !bApp && !isToB }">
        <a
          :href="`tel:${data.telephone}`"
          data-stat-id="phone"
          :data-stat-ep="
            JSON.stringify({
              productId: data.insuranceTypeId,
            })
          "
        >
          <template v-if="bApp">{{ data.telephone }}</template>
          <template v-else>
            <i class="iconfont icon-phone_line" />
            <span>联系我</span>
          </template>
        </a>
      </div>
      <div class="card-item" :class="[bApp ? 'card-edit' : 'card-view']">
        <a
          v-if="!isToB"
          :href="data.nameCard"
          data-stat-id="edit"
          :data-stat-ep="
            JSON.stringify({
              productId: data.insuranceTypeId,
            })
          "
        >
          <span v-if="bApp" class="inner">编辑名片</span>
          <template v-else>
            <i class="iconfont icon-business_card" />
            <span>查看名片</span>
          </template>
        </a>
      </div>
    </div>
    <footer class="function-bar">
      <div class="function-inner">
        <div class="fn-right">
          <template v-if="isAdd">
            <div v-if="!isBroker" class="btn add" @click="handleClick('add')">
              确定添加
            </div>
          </template>
          <template v-else>
            <div
              v-if="isEdit"
              class="btn edit after-bdr"
              @click="handleClick('edit')"
            >
              修改方案
            </div>
            <div
              v-if="!isBroker"
              class="btn generate after-bdr"
              @click="handleClick('generate')"
            >
              导出文档
            </div>
            <div
              v-if="isNotSaShow"
              class="btn picture after-bdr"
              @click="handleClick('generate-image')"
            >
              导出图片
            </div>
            <div
              class="btn share"
              data-stat-id="share_bottom"
              @click="handleClick('share')"
            >
              分享
            </div>
          </template>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  bApp,
  isBroker,
  isToB,
  isBxs,
  isWeCom,
  isMiniBankInsurance
} from 'base/config'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'

const EVENT_CLICK = 'click'

export default {
  props: {
    data: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data () {
    this.bApp = bApp
    this.isBroker = isBroker
    this.isToB = isToB
    this.isBxs = isBxs
    return {
      isCardShow: true
    }
  },
  computed: {
    isCardRealShow () {
      // 经纪｜企微｜企微小程序 不显示
      return this.isCardShow && !isBroker && !isWeCom && !isMiniBankInsurance
    },
    isNotSaShow () {
      return !isBroker && !isWeCom && !isMiniBankInsurance
    },
    isMember () {
      const { data } = this
      return data.memberLevelName || data.offlineBroker
    },
    isMedalShow () {
      const { data } = this
      return data.memberLevelMedal && !data.offlineBroker
    }
  },
  created () {
    const nocard = getUrlParam('nocard')
    nocard == 1 && (this.isCardShow = false)
    const uuid = getUrlParam('uuid')
    const theme = getUrlParam('theme')
    const sourceFrom = JSON.stringify({ uuid, theme })
    this.data.nameCard = getUrlByAddingParam(
      {
        sourceFrom
      },
      this.data.nameCard
    )
  },
  methods: {
    resizePicture (url, size) {
      if (isNaN(size) || !url) return url
      return `${url}?x-oss-process=image/resize,m_mfit,h_${size},w_${size}`
    },
    jumpToCard (url) {
      if (isToB) return
      location.href = url
    },
    handleClick (type) {
      this.$emit(type)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'variable';

.card-function-bar {
  verflow: hidden;
  position: relative;
  width: 94.667%;
  margin: 0 auto 10px;
  font-size: 13px;
  border-radius: 4px;
  background-color: #fff;
  text-align: center;
  .after-bd-r:after {
    height: 40%;
    bottom: 30%;
    background-color: rgba(51, 51, 51, 0.4);
  }
  .card-wrap {
    width: 100%;
    display: flex;
  }
}

.card-item {
  float: left;
  position: relative;
  background-color: #fff;
  > a {
    display: block;
    height: 100%;
    line-height: 60px;
    color: var(--thre-color);
  }
}

.card-user {
  width: 38.7%;
}

.card-telephone {
  width: 33%;
}

.card-edit,
.card-view {
  width: 28.3%;
}

.card-telephone,
.card-view {
  .iconfont {
    margin-right: 6px;
    font-size: 18px;
    line-height: 1;
    vertical-align: middle;
  }
  span {
    font-size: 14px;
    vertical-align: middle;
    line-height: 1;
  }
}

.card-edit {
  span {
    display: inline-block;
    padding: 9px 12px;
    font-size: 13px;
    line-height: 1.3;
    border-radius: 6px;
  }
}

.line {
  &:before,
  &:after {
    @apply --bd-w;
    background-color: var(--efive-color);
    height: 58%;
    top: 21%;
  }
  &:before {
    left: 6%;
  }
  &:after {
    right: 6%;
  }
}

.name-card {
  .info {
    padding-left: 44.1%;
    font-size: 15px;
    text-align: left;
    p {
      font-size: 16px;
      font-weight: 400;
      @apply --text-ellipsis;
    }
  }
  .head {
    overflow: hidden;
    position: absolute;
    left: 10%;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    &.circle {
      border-radius: 100%;
      > img {
        border-radius: 100%;
      }
    }
    > img {
      width: 100%;
    }
  }
  .member {
    padding-top: 13px;
    line-height: 1.2;
    > p {
      @apply --text-ellipsis;
    }
    .name {
      padding-right: 21px;
      span {
        display: inline-block;
        max-width: 100%;
        @apply --text-ellipsis;
      }
    }
    p:last-child {
      margin-top: 3px;
      font-size: 12px;
      color: #999;
      transform: scale(0.83);
      transform-origin: left top;
    }
  }
}

.icon-member {
  z-index: 1;
  position: absolute;
  display: inline-block;
  overflow: hidden;
  width: 15px;
  height: 15px;
  margin-left: 3px;
  img {
    width: 100%;
  }
}

.function-bar {
  z-index: 100;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 7px 0;
  box-sizing: content-box;
  font-size: 15px;
  text-align: center;
  background-color: #f8f8f8;
  .function-inner {
    display: flex;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: 10px;
    padding-right: 10px;
  }
  .fn-right {
    flex: 1;
    display: flex;
  }
  .btn {
    margin: 0 4px;
    font-size: 14px;
    line-height: 36px;
    border-radius: 6px;
    color: #333;
    background-color: #fff;
    white-space: nowrap;
  }
  .add {
    flex: 1;
  }
  .share,
  .picture {
    flex: 2;
  }
  .generate {
    flex: 2;
  }
  .edit {
    flex: 1;
    + .generate {
      flex: 1;
      + .picture {
        flex: 1;
      }
    }
  }
  .generate,
  .picture,
  .edit {
    &:after {
      border-radius: 12px;
    }
  }
}

@media screen and (device-width <= 320px) {
  .card-function-bar {
    .card-telephone,
    .card-view {
      span {
        font-size: 12px;
      }
    }
  }
  .name-card {
    .head {
      left: 4%;
    }
    .info {
      p {
        font-size: 13px;
      }
    }
  }
  .icon-member {
    margin-left: 0;
  }
}
</style>
